export var createMuiDialogContentOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            padding: spacing(9, 12, 4),
            "&:first-child": {
                paddingTop: spacing(12),
            },
            "&:last-child": {
                paddingBottom: spacing(12),
            },
        },
    });
};
//# sourceMappingURL=MuiDialogContent.js.map